
class exports.Crop

    constructor: ->
        @id = null
        @name = ''
        @lineups_id = null
        @has_spp = false
        @edited_by = ''
        @edited_at = ''

# this is kind of weird and cool that it works..
# exports.Crop.makeInstance = (props) ->
#     crop = new this
#     for k, v of props
#         crop[k] = v
